import { useModalContext } from '@fourthwall/components'

import { useSubscriptionOffers } from '../../modules/Subscriptions'
import { CreateProductModal } from '../CreateProduct/CreateProductModal'

export const useCreateProduct = () => {
  const { open } = useModalContext()
  const {
    shouldShowLimitsModal,
    shouldShowUpgradeModal,
    openSubscriptionOffersLimitModal,
    openSubscriptionOffersUpgradeModal,
  } = useSubscriptionOffers()

  const openCreateProductModal = () => {
    if (shouldShowLimitsModal) {
      openSubscriptionOffersLimitModal()

      return
    }

    if (shouldShowUpgradeModal) {
      openSubscriptionOffersUpgradeModal({
        source: 'create_product',
        onSuccess: () => open(CreateProductModal),
      })

      return
    }

    open(CreateProductModal)
  }

  return {
    openCreateProductModal,
  }
}
